import React, { useState } from 'react';
import MasterPage from './MasterPage';
import readUrl from './commons'


const PrintingAndPackagingERP = () => {
  //const getLocation = () => {
  //  const pathArray = window.location.pathname.split("/");
  //  if (pathArray.length === 4) {
  //    const loc = pathArray[pathArray.length - 1];
  //    return `in ${loc.charAt(0).toUpperCase() + loc.slice(1)}`;
  //  }
  //  return "";
  //};

  //const location = getLocation();

  //document.title = `Best Printing And Packaging Industry Software ${location} | ERP Systems | Business Management Solutions - Tejaxo Software`;
  //document.querySelector("meta[name='description']").setAttribute(
  //  "content",
  //  `Tejaxo Software is a High Rated Indian Printing And Packaging Industry Software ${location}, providing award-winning Enterprise Resource Planning (ERP) software for Printing And Packaging Industries, business management solutions, services and support.`
  //);
  //document.querySelector("meta[name='keywords']").setAttribute(
  //  "content",
  //  `Tejaxo Printing And Packaging Industry Software ${location}, Tejaxo Printing And Packaging Industry Software`
  //);

    var aaa = readUrl();
    const [state, setState] = useState(aaa);
    return (
        <MasterPage state={state} >
    <section id="about" style={{ backgroundColor: "white" }}>
      <div className="container">
        <div className="row">
                        <h1 className="mkdf-page-title entry-title">
                            ERP Software Solution For The Printing And Packaging Industry {state.condText}
          </h1>
        </div>
        <hr />
        <div className="row">
          <p>
            Today more than ever, the printing and packaging industry is required to react creatively, quickly and reliably to the requirements of its business partners. In addition, as a company they must act efficiently, ecologically and economically. Although the dynamic consumer goods market offers the industry many opportunities, it is important to react quickly to new customer wishes due to intense competition. Only those who take up trends flexibly, develop innovative products and are commercially convincing will lead the market.
          </p>
        </div>
        <br />
        <div className="row">
          <h3>The advantages of an ERP industry solution</h3>
        </div>
        <br />
        <div className="row">
          <div className="col-sm-6">
            <h4>Acting flexibly, also in the future</h4>
            <p>
              The cc|print and packaging industry solution is based on the Microsoft Dynamics 365 for Finance and Operations ERP system and has been specifically tailored to meet the needs of the printing and packaging industry. The software runs on an open technology that can be easily integrated into the existing system environment and allows consistent operations across multiple sites. With the Microsoft-certified application you are on the safe side when it comes to updates � even in case of individual adjustments.
            </p>
            <br />
            <h4>Solid partnerships</h4>
            <p>
              As an international IT company, Microsoft represents long-term security of investment. Regular releases for Dynamics 365 ensure that users are always up to date in technical terms. With over 950 employees at 40 locations in 12 countries, Tejaxo is one of the world's leading Microsoft Dynamics partners. The product portfolio of the end-to-end solution provider ranges from ERP systems through to CRM and data analytics to artificial intelligence and the Internet of Things (IoT). The cc|print and packaging industry solution reflects Tejaxo�s deep industry expertise and is internationally tried and tested.
            </p>
          </div>
          <div className="col-sm-6">
            <h4>Integrating new technologies conveniently</h4>
            <p>
              The cc|print and packaging industry solution is closely related to Microsoft standards. In this way, for example, Business Intelligence applications or technologies from the IoT environment can be integrated easily. New requirements such as predictive machine maintenance or real-time evaluations can be implemented conveniently.
            </p>
            <br />
            <h4>On your own servers or in the cloud</h4>
            <p>
              cc|print and packaging provides your employees with the required information across the entire process chain. The software can be used on premise, in the cloud or in a hybrid environment.
            </p>
          </div>
        </div>
      </div>
            </section>
        </MasterPage>
  );
};

export default PrintingAndPackagingERP;